import { render, staticRenderFns } from "./FullViewModeSwitch.vue?vue&type=template&id=159ef694&lang=pug&"
import script from "./FullViewModeSwitch.vue?vue&type=script&lang=js&"
export * from "./FullViewModeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FullViewModeSwitch.vue"
export default component.exports